import { OpenInNew as OpenInNewIcon, CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import { Box, Tooltip, Chip, Link as MuiLink } from '@mui/material';
import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { ActionsCell } from 'ml-react-component-library';
import { Link as RouterLink } from 'react-router';

import type { ParsedIManageDocument } from '@/apps/engagement-letter-database/hooks/useParseRecords';
import { buildIManageUrl } from '@/shared/helpers/imanageUrlUtils';

interface DocumentColumnHandlers {
  onEdit: (row: ParsedIManageDocument) => void;
  onView: (row: ParsedIManageDocument) => void;
  /** When false, the Edit action is hidden (user lacks update permission). */
  canEdit?: boolean;
}

const createColumns = ({ onEdit, onView, canEdit = true }: DocumentColumnHandlers): GridColDef<ParsedIManageDocument>[] => [
  { field: 'docName', headerName: 'Document Name', flex: 1 },
  { field: 'docId', headerName: 'iManage Doc Number', flex: 1 },
  {
    field: 'iManageLink',
    headerName: 'iManage Link',
    flex: 1,
    renderCell: (params) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Tooltip title="Link resolved successfully">
          <CheckCircleIcon fontSize="small" color="success" />
        </Tooltip>
        <MuiLink
          component={RouterLink}
          to={buildIManageUrl(params.row.docId)}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            color: 'primary.main',
          }}
        >
          Open in iManage
          <OpenInNewIcon fontSize="small" />
        </MuiLink>
        <Tooltip title={`Document: ${params.row.docName}`}>
          <Chip
            label={params.row.docId}
            size="small"
            variant="outlined"
            sx={{ fontSize: '0.7rem', height: 20 }}
          />
        </Tooltip>
      </Box>
    ),
  },
  {
    field: 'actions',
    headerName: 'Actions',
    sortable: false,
    filterable: false,
    renderCell: (params: GridRenderCellParams<ParsedIManageDocument>) => (
      <ActionsCell
        {...params}
        onEdit={canEdit ? ({ row }) => onEdit(row as ParsedIManageDocument) : undefined}
        onView={({ row }) => onView(row as ParsedIManageDocument)}
      />
    ),
  },
];

export { createColumns };
